import { callAPI, chameau, GATEWAY_PROXY, METHODS } from "utils/apiUtils";

export function loginService(
	options = { email: "", password: "", accountId: null, challenge : null, code : null },
	successCallback = () => { },
	failureCallback = () => { }
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/login",
			body: chameau(options),
		},
		successCallback,
		failureCallback
	);
}


/**
 * Login with OAuth code against CASDoor
 * 
 * @param {String} options.code - OAuth code
 * @param {String} options.state - OAuth state
 * @param {Number} options.partnerId - AccountId auth context
 */
export function CASLoginService(
	options = { code: "", state: "", accountId: 0 },
	successCallback = () => { },
	failureCallback = () => { }
) {
	callAPI(
		{
			method: METHODS.get,
			url: `${GATEWAY_PROXY}/login/${options.accountId}`,
			query: {
				code: options.code,
				state: options.state
			},
		},
		successCallback,
		failureCallback
	);
}

export function impersonateService(
	options = { accountId: null },
	successCallback = () => { },
	failureCallback = () => { }
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/impersonate",
			body: options,
		},
		successCallback,
		failureCallback
	);
}

export function amILoggedIn(
	options = {},
	successCallback = () => { },
	failureCallback = () => { }
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/amiloggedin",
			method: METHODS.get,
		},
		successCallback,
		failureCallback
	);
}

export function logoutService(
	options = {},
	successCallback = () => { },
	failureCallback = () => { }
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/logout",
			method: METHODS.get,
			skipRetry: true,
		},
		successCallback,
		failureCallback
	);
}
